import tokens from '@veneer/tokens';
import math from 'polished/lib/math/math';
var defaultTheme = {
  density: {
    standard: {
      borderRadius: tokens.layout.cornerRadius3,
      borderRadius1: tokens.layout.cornerRadius2,
      borderRadius2: tokens.layout.cornerRadius1,
      borderRadius3: tokens.layout.cornerRadius2,
      borderRadius4: tokens.layout.cornerRadius3,
      borderRadius5: tokens.layout.cornerRadius4,
      fontSizeThree: tokens.typography.size2,
      lineHeightThree: tokens.typography.lineHeight3,
      orbitalOne: tokens.layout.size1,
      orbitalTwo: tokens.layout.size2,
      orbitalThree: tokens.layout.size3,
      orbitalFour: tokens.layout.size4,
      orbitalFive: tokens.layout.size5,
      orbitalSix: tokens.layout.size6,
      orbitalSeven: tokens.layout.size7,
      orbitalEight: tokens.layout.size8,
      orbitalIntermediate: tokens.layout.size3,
      orbitalModalHorizontal: math("".concat(tokens.layout.size8, " + ").concat(tokens.layout.size4)),
      orbitalModalVertical: math("".concat(tokens.layout.size8, " + ").concat(tokens.layout.size2)),
      passwordRequirements: {
        iconSize: tokens.layout.size6,
        itemMargin: "calc(".concat(tokens.layout.size1, " - 2px)"),
        bulletMargin: "".concat(tokens.layout.size2, " ").concat(tokens.layout.size3, " ").concat(tokens.layout.size2, " ").concat(tokens.layout.size2),
        iconPadding: 0,
        iconWidthHeight: tokens.layout.size6
      },
      helperText: {
        iconErrorMarginTop: 0,
        textHelperMarginTop: math("".concat(tokens.layout.size1, " - 2px"))
      }
    },
    high: {
      borderRadius: tokens.layout.cornerRadius2,
      borderRadius1: tokens.layout.cornerRadius1,
      borderRadius2: tokens.layout.cornerRadius1,
      borderRadius3: tokens.layout.cornerRadius2,
      borderRadius4: tokens.layout.cornerRadius3,
      borderRadius5: tokens.layout.cornerRadius3,
      fontSizeThree: tokens.typography.size1,
      lineHeightThree: tokens.typography.lineHeight2,
      orbitalOne: 0,
      orbitalTwo: tokens.layout.size1,
      orbitalThree: tokens.layout.size2,
      orbitalFour: tokens.layout.size3,
      orbitalFive: tokens.layout.size4,
      orbitalSix: tokens.layout.size5,
      orbitalSeven: tokens.layout.size6,
      orbitalEight: tokens.layout.size7,
      orbitalModalHorizontal: math("".concat(tokens.layout.size8, " + ").concat(tokens.layout.size2)),
      orbitalModalVertical: tokens.layout.size8,
      orbitalIntermediate: math("".concat(tokens.layout.size3, " / 2")),
      passwordRequirements: {
        iconSize: tokens.layout.size5,
        itemMargin: 0,
        bulletMargin: "".concat(math("".concat(tokens.layout.size1, " + 2px")), " ").concat(math("".concat(tokens.layout.size2, " + 2px")), " ").concat(math("".concat(tokens.layout.size1, " + 2px")), " ").concat(math("".concat(tokens.layout.size1, " + 2px"))),
        iconPadding: "calc(".concat(tokens.layout.size1, " - 2px)"),
        iconWidthHeight: tokens.layout.size5
      },
      helperText: {
        iconErrorMarginTop: math("".concat(tokens.layout.size1, " - 2px")),
        textHelperMarginTop: math("".concat(tokens.layout.size1, " - 3px"))
      }
    }
  },
  shape: {
    sharp: {
      borderRadius: tokens.layout.cornerRadius0,
      borderRadius1: tokens.layout.cornerRadius0,
      borderRadius2: tokens.layout.cornerRadius0,
      borderRadius3: tokens.layout.cornerRadius0,
      borderRadius4: tokens.layout.cornerRadius0,
      borderRadius5: tokens.layout.cornerRadius0
    }
  },
  elevation: {
    auto: 'auto',
    header: 1000,
    sideMenu: 1100,
    sideBar: 1200,
    modal: 1300,
    popover: 1400,
    tooltip: 1500,
    toast: 1600
  }
};
export default defaultTheme;